import React, { useState } from "react";
import { Controller, Scene } from 'react-scrollmagic'
import { Tween, Timeline } from 'react-gsap'


function Roadmap() {
    var countDownDate = new Date(2022, 10, 1, 17, 0, 0)
    var x = setInterval(function () {
        var now = new Date().getTime()
        var distance = countDownDate - now
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        document.getElementById('countdown').textContent = `${days} d ${hours} h ${minutes} m ${seconds} s`
        if (distance < 0) {
            clearInterval(x)
            document.getElementById('countdown').textContent = 'On Sale'
        }
    }, 1000)


    return (
        <section id='roadmap' className='page2'>

            <div className="title-div">
                <h3 className="road-title">THIS IS THE WAY  </h3>
                <div className="underline"></div>
            </div>
            <div className="backcards">
                <div className="part1">
                    <div className="flip-card">
                        <div className="flip-card-inner">
                            <div className="flip-card-front">
                                <div className="raffle-wheel">
                                    <img className="stick-img" src="././images/asd1.png" />
                                    <img className="wheel-img" src="././images/cark1.png" />
                                </div>
                                <h2 className="raffle-title">01 : Raffle</h2>
                            </div>
                            <div className="flip-card-back">
                                <div className="back-left">
                                    <h3>Follow us on twitter to win some pre-sale privileges and gifts.</h3>
                                </div>
                                <div className="back-right">
                                    <p>We will have some <strong>privileges</strong> and <strong>giveaways</strong> before the sale time.<br/><br/>
                                        Maybe we can't be enlightened by candlelight, but you will understand our intention.<br/><br/>
                                        We want to offer the best for you . 
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flip-card1">
                        <div className="flip-card-inner1">
                            <div className="flip-card-front1">
                                <div className="sale-div">
                                    <img className="sale-img" src="././images/stagesale.png" />
                                    <h2 className="sale-title">02 : Sale Time </h2>
                                </div>
                            </div>
                            <div className="flip-card-back1">
                                <div className="back-left">
                                    <h3>Sale time count down: ⏱️</h3>
                                    <h3 className="backparagraph" id="countdown"></h3>
                                </div>
                                <div className="back-right">
                                    <p>
                                        500 NFT artifacts from our Armadillos Origins collection will be presented to you.                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="part2">
                    <div className="flip-card3">
                        <div className="flip-card-inner3">
                            <div className="flip-card-front3">
                                <div className="raffle-wheel">
                                    <img className="flip3" src="././images/flip3.jpg" />
                                </div>
                                <h2 className="stage3-title">03 : Armos Series  </h2>
                            </div>
                            <div className="flip-card-back3">
                                <div className="back-left">
                                    <h3>Armos Series</h3>
                                </div>
                                <div className="back-right">
                                    <p>
                                        Our <strong>Armos Collection</strong> will be launched simultaneously with our clothing brand.<br/><br/>
                                        Of course , for those who own the Origins collection , various privileges will be provided for pre - sale and clothing brand .
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flip-card4">
                        <div className="flip-card-inner4">
                            <div className="flip-card-front4">
                                <div className="tshirt-div">
                                    <img className="tshirt-img" src="././images/stagetshirt.png" />
                                    <h2 className="tshirt-title">04 : Clothing </h2>
                                </div>
                            </div>
                            <div className="flip-card-back4">
                                <div className="back-left">
                                    <h3>Clothing products of our beloved characters meet you.</h3>
                                </div>
                                <div className="back-right">
                                    <p>
                                        Armos T Shirts and other apparel will be launched in the future as a premium fashion brand for the web3 and crypto space.<br/><br/>
                                        Let's not forget that it will be a <strong>limited</strong> number.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section >

    )

}

export default Roadmap

